import React, { useState } from 'react';
import NavBar from '../component/NavBar.js';
import Goods from '../component/Goods.js';

function Bookmarks() {
  const [ showFilter , setShowFilter] = useState(false);

  function handleFilterClick(e){
    setShowFilter(true);
  }

  function handleFilterClose(e){
    if(!document.getElementsByClassName('rdrDateRangeWrapper')[0].contains(e.target)){
        setShowFilter(false);
    }
  }

  return (
    <>
      <NavBar onFilterClick={handleFilterClick} />
      <Goods showFilter={showFilter} onFilterClose={handleFilterClose} type="bookmark" />
    </>
  );
}

export default Bookmarks;
